import  { useModels } from "../../helpers/models";
import { useTranslation } from 'react-i18next';

const useMenuConfig = () => {
    const { t } = useTranslation();
    const models = useModels();

    return [
        {
            title: t("menu.main_panel"),
            navigate: "/",
            icon: models.icons.home,
            permission: "MAIN_PANEL_READ"
        },
        {
            title: t("menu.machine_models"),
            navigate: "/machine-models",
            icon: "fa-hard-drive",
            permission: "PACKAGING_LINES_VIEW"
        },
        {
            title: t("menu.packing_lines"),
            navigate: "/lines",
            icon: models.icons.line,
            permission: "PACKAGING_LINES_VIEW"
        },
        {
            title: t("menu.formats"),
            navigate: "/formats",
            icon: models.icons.format,
            permission: "FORMATS_VIEW"
        },
        {
            title: t("menu.formats_withdrawn"),
            navigate: "/formatsDeleted",
            icon: models.icons.trash,
            permission: "FORMATS_WITHDRAWN"
        },
        {
            title: t("menu.font_management"),
            navigate: "/fonts",
            icon: models.font.icon,
            permission: "FONT_MANAGEMENT_VIEW"
        },
        {
            title: t("menu.fast_acting_parts"),
            navigate: "/fastActionParts",
            icon: "fa-rotate",
            permission: "FAST_ACTING_PART_VIEW"
        },
        {
            title: models.production.title,
            navigate: models.production.url,
            icon: models.production.icon,
            permission: "PRODUCTION_VIEW"
        },
        {
            title: models.storagePlace.title,
            navigate: models.storagePlace.url,
            icon: models.storagePlace.icon,
            permission: "STORAGE_PLACE_VIEW"
        },
        {
            title: t("menu.admin_panel"),
            navigate: "/admin",
            icon: "fa-list-alt",
            permission: "ADMIN_PANEL_VIEW"
        },
    ];
};

export default useMenuConfig;
